module.exports = __webpack_public_path__ + "static/media/signage-indoor-img10.6b9b1c12.jpg";